import Ngql from 'gql/ninegql'
import type { NineNodeBase, NineQuery, NineMutation } from 'gql/ninegql'

// Signature node field definition
const signatureNodeField = {
  id: true,
  title: true,
  content: true,
}

const signatureNode: NineNodeBase = Ngql.Node(signatureNodeField, 'SignatureNode')

// User signature node field definition
const userSignatureNodeField = {
  id: true,
  userId: true,
  signatureId: true,
  default: true,
  signature: signatureNode,
}

const userSignatureNode: NineNodeBase = Ngql.Node(userSignatureNodeField)

// Query for signature list
const querySignatureList: NineQuery = Ngql.Query('querySignatureList', {
  allUserSignatures: Ngql.NodeConnection(userSignatureNode, {
    // sort: Ngql.Var('sort', '[AccountSignatureNodeSortEnum]'),
    // pageNum: Ngql.Var('pageNum', 'Int'),
    // pageSize: Ngql.Var('pageSize', 'Int'),
    // filters: Ngql.Var('filters', 'AccountSignatureFilter'),
  }),
})

// Mutation to set default signature
const mutationDefaultSignature: NineMutation = Ngql.Mutation('defaultSignature', {
  defaultSignature: Ngql.Node(
    {
      result: true,
      ok: true,
    },
    null,
    false,
    {
      signatureGid: Ngql.Var('signatureGid', 'String!'),
      isDefault: Ngql.Var('isDefault', 'Boolean'),
    },
  ),
})

// Mutation to create signature
const mutationCreateSignature: NineMutation = Ngql.Mutation('createSignature', {
  createSignature: Ngql.Node(
    {
      signature: signatureNode,
      ok: true,
    },
    null,
    false,
    {
      signatureData: Ngql.Var('signatureData', 'SignatureCreateInput!'),
    },
  ),
})

// Mutation to update signature
const mutationUpdateSignature: NineMutation = Ngql.Mutation('updateSignature', {
  updateSignature: Ngql.Node(
    {
      signature: signatureNode,
      ok: true,
      errors: true,
    },
    null,
    false,
    {
      signatureData: Ngql.Var('signatureData', 'SignatureUpdateInput!'),
      signatureGid: Ngql.Var('signatureGid', 'String!'),
    },
  ),
})

// Signature node array for delete mutation
const signatureNodeArray: NineNodeBase = Ngql.Node(signatureNodeField, null, false, null, true)

// Mutation to delete signature
const mutationDeleteSignature: NineMutation = Ngql.Mutation('deleteSignature', {
  deleteSignature: Ngql.Node(
    {
      results: signatureNodeArray,
      ok: true,
      errors: true,
    },
    null,
    false,
    {
      signatureGids: Ngql.Var('signatureGids', '[String!]'),
    },
  ),
})

// App config node field definition
const AppConfigNodeField = {
  id: true,
  name: true,
  config: true,
  preset: true,
  // createdAt: true,
  // updatedAt: true,
}

const AppConfigNode: NineNodeBase = Ngql.Node(AppConfigNodeField, 'AppConfigNode')

// Query for app config list
const queryAppConfigList: NineQuery = Ngql.Query('appConfigList', {
  allAppconfigs: Ngql.NodeConnection(AppConfigNode, {
    // sort: Ngql.Var('sort', '[AppconfigNodeSortEnum]'),
    // pageNum: Ngql.Var('pageNum', 'Int'),
    // pageSize: Ngql.Var('pageSize', 'Int'),
    // filters: Ngql.Var('filters', 'AppconfigFilter'),
  }),
})

// Exported queries object
const queries = {
  querySignatureList,
  mutationDefaultSignature,
  mutationCreateSignature,
  mutationUpdateSignature,
  mutationDeleteSignature,
  queryAppConfigList,
}

export default queries
